module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('b-modal', {
    ref: "missionDuplicateModal",
    attrs: {
      "id": "missionDuplicateModal",
      "title": _vm.$t('mission.modal.duplicate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.duplicateMission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.duplicate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slug'),
      "state": _vm.missionDuplicateSlugState,
      "feedback": _vm.missionDuplicateSlugFeedback,
      "description": _vm.$t('mission.duplicate.slug.description')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.missionDuplicateSlugAvailable
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.missionDuplicateSlugFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.slug),
      callback: function($$v) {
        _vm.missionDuplicateData.slug = $$v
      },
      expression: "missionDuplicateData.slug"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": "success",
      "description": _vm.$t('mission.duplicate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionDuplicateData.title),
      callback: function($$v) {
        _vm.missionDuplicateData.title = $$v
      },
      expression: "missionDuplicateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slottingTime'),
      "state": _vm.missionDuplicateSlottingTimeState,
      "feedback": _vm.missionDuplicateSlottingTimeFeedback,
      "description": _vm.$t('mission.duplicate.slottingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.slottingTime),
      callback: function($$v) {
        _vm.missionDuplicateData.slottingTime = $$v
      },
      expression: "missionDuplicateData.slottingTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.startTime'),
      "state": _vm.missionDuplicateStartTimeState,
      "feedback": _vm.missionDuplicateStartTimeFeedback,
      "description": _vm.$t('mission.duplicate.startTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.startTime),
      callback: function($$v) {
        _vm.missionDuplicateData.startTime = $$v
      },
      expression: "missionDuplicateData.startTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.endTime'),
      "state": _vm.missionDuplicateEndTimeState,
      "feedback": _vm.missionDuplicateEndTimeFeedback,
      "description": _vm.$t('mission.duplicate.endTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.endTime),
      callback: function($$v) {
        _vm.missionDuplicateData.endTime = $$v
      },
      expression: "missionDuplicateData.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.briefingTime'),
      "state": _vm.missionDuplicateBriefingTimeState,
      "feedback": _vm.missionDuplicateBriefingTimeFeedback,
      "description": _vm.$t('mission.duplicate.briefingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.briefingTime),
      callback: function($$v) {
        _vm.missionDuplicateData.briefingTime = $$v
      },
      expression: "missionDuplicateData.briefingTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.duplicate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionDuplicateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionDuplicateData.visibility),
      callback: function($$v) {
        _vm.missionDuplicateData.visibility = $$v
      },
      expression: "missionDuplicateData.visibility"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.user.community) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.creator.addToCommunity'),
      "state": "success",
      "description": _vm.missionDuplicateAddToCommunityDescription
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionDuplicateData.addToCommunity),
      callback: function($$v) {
        _vm.missionDuplicateData.addToCommunity = $$v
      },
      expression: "missionDuplicateData.addToCommunity"
    }
  })], 1)], 1) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission duplicate actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.duplicateMission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionDuplicateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b61b39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionDuplicateModal.vue
// module id = 539
// module chunks = 0